export default {
    employeeFiledLoans: [],
    reviewer: [],
    approver: [],
    photoUpload:[]
}